
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      nameCategory: '',
      idValiditySelected: '',
      getProducts: [],
      singleValidity: [],
      radios: null,
      isProductSelected: null,
      tabs: null,
      tab: null,
      contentProduto: false,
      overlay: true,
    }
  },
  head() {
    const pageTitle = `Certificado Digital ${this.categorySelected.nome} - Senha Digital`
    const pageDescription = `Certificado Digital ${this.categorySelected.nome} rápido e seguro para sua empresa. Facilite a assinatura de documentos eletronicamente.`
    const contentSeo = `Certificado Digital ${this.categorySelected.nome} – Senha Digital`
    return {
      title: pageTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: pageDescription,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: contentSeo,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: contentSeo,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: `O ${this.categorySelected.nome} da Senha Digital oferece a segurança que sua empresa precisa para operações digitais.`,
        },

        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: contentSeo,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: `O ${this.categorySelected.nome} da Senha Digital proporciona assinaturas eletrônicas seguras para sua empresa.`,
        },
      ],
    }
  },

  computed: {
    ...mapGetters('product-open', [
      'allProducts',
      'filterOneCategory',
      'allCategorias',
    ]),
    ...mapGetters('unidade', ['unidadeInformation']),
    categorySelected() {
      const x = this.filterOneCategory(this.$route.params.categoria)
      return x
    },

    filteredProducts() {
      const validadeProdutoId = this.idValiditySelected
      return this.getProducts.filter(
        (item) => item.tipoProduto === validadeProdutoId
      )
    },
    isSmallScreen() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
  async mounted() {
    await this.fetchProductsIfNeeded()
    await this.loadProductOpen()
    this.overlay = false
  },

  methods: {
    ...mapActions('cart', ['adicionarCart']),
    ...mapActions('product-open', ['fetchProdutoOpen', 'fetchCategoriaOpen']),
    async loadProductOpen() {
      const unidade = this.unidadeInformation.cpfcnpj
      const cnpjWhiteLaibel = '19520630000115'
      const idCategoriaSelected = this.filterOneCategory(
        this.$route.params.categoria
      ).id
      const categoria = idCategoriaSelected
      const cnpj = !unidade ? cnpjWhiteLaibel : unidade
      try {
        await this.fetchProdutoOpen({
          cnpj,
          categoria,
        })
        const uniqueSortedProducts = [
          ...new Set(this.allProducts.map((product) => product.tipoProduto)),
        ].sort((a, b) => {
          const numA = parseInt(a)
          const numB = parseInt(b)

          // Ordena do menor para o maior
          return numA - numB
        })
        this.singleValidity = uniqueSortedProducts
        this.idValiditySelected = uniqueSortedProducts[0]

        const produtosSemProdutorRural = []
        let produtorRural = null
        this.allProducts.forEach((item) => {
          if (item.nome === 'Produtor Rural') {
            produtorRural = {
              ...item,
              nomeVenda: `${this.categorySelected.nome} ${item.nome} ${item.tipoProduto}`,
            }
          } else {
            produtosSemProdutorRural.push({
              ...item,
              nomeVenda: `${this.categorySelected.nome} ${item.nome} ${item.tipoProduto}`,
            })
          }
        })

        const productsMerge = [
          ...produtosSemProdutorRural,
          ...(produtorRural ? [produtorRural] : []),
        ]
        // const productsMerge = this.allProducts.map((item) => {
        //   return {
        //     ...item,
        //     nomeVenda: `${this.categorySelected.nome} ${item.nome} ${item.tipoProduto}`,
        //   }
        // })
        this.getProducts = productsMerge
      } catch (error) {
        console.error(error)
        this.$toast.error(error)
      } finally {
        this.contentProduto = true
      }
    },

    tabSelected(item) {
      this.idValiditySelected = item
    },

    addItemToCart(item) {
      this.isProductSelected = item
    },

    purchase() {
      if (!this.radios) {
        return this.$toast.warning('Selecione um produto')
      }
      try {
        this.adicionarCart(this.isProductSelected)
        this.$router.push('/compra-pedido')
      } catch (error) {
        this.$toast.error('error: ' + error)
        console.error(error)
      }
    },

    async fetchProductsIfNeeded() {
      if (this.allCategorias.length === 0) {
        try {
          await this.fetchCategoriaOpen()
        } catch (error) {
          console.error(error)
        }
      }
    },
  },
}
